import {Component, Input, OnInit} from '@angular/core';
import {AbstractComponent} from "@components";
import {Country, EventItem, EventItemType, Lookups, Message, UserDetail} from "@model";
import {PublicEventsService, UserDetailService} from "@services";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {EVENT_DETAILS} from "../../../../app-routing.module";
import {tap} from 'rxjs';

@Component({
  selector: 'app-my-tracey',
  templateUrl: './my-tracey.component.html',
  styleUrl: './my-tracey.component.scss'
})
export class MyTraceyComponent extends AbstractComponent implements OnInit {
  @Input() tab: "favorites" | "finished" | "upcoming" = "finished";
  @Input() countries: Country[] = [];
  @Input({required: true}) languages: Lookups[] = [];
  @Input() currentUserDetails: UserDetail | undefined;
  @Input() unreadMessages: Message[] | undefined;
  users: UserDetail[] = [];
  hasMoreEvents: boolean = false;
  activeTab: number = 1;
  EventItemType = EventItemType;

  favoriteItems: EventItem[] = [];
  upcomingRegisteredEvents: EventItem[] = [];
  pastRegisteredEvents: EventItem[] = [];

  isLoadingFavoriteItems: boolean = false;
  isLoadingUpcomingRegisteredEvents: boolean = false;
  isLoadingPastRegisteredEvents: boolean = false;

  constructor(private router: Router, public translocoService: TranslocoService, private route: ActivatedRoute,
              private publicEventsService: PublicEventsService, private userService: UserDetailService) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.push(this.userService.currentUserDetails.subscribe((userDetails: UserDetail | undefined): void => {
      this.currentUserDetails = userDetails;
    }));

    this.subscriptions.push(this.publicEventsService.favoriteEvents.subscribe(favoriteEvents => {
      this.favoriteItems = favoriteEvents?.result ?? [];
    }));
    this.subscriptions.push(this.publicEventsService.upcomingRegisteredEvents.subscribe(upcomingRegisteredEvents => {
      this.upcomingRegisteredEvents = upcomingRegisteredEvents?.result ?? [];
    }));
    this.subscriptions.push(this.publicEventsService.pastRegisteredEvents.subscribe(pastRegisteredEvents => {
      this.pastRegisteredEvents = pastRegisteredEvents?.result ?? [];
    }));

    this.activeTab = this.calculateActiveTab();

    this.isLoadingFavoriteItems = true;
    this.isLoadingPastRegisteredEvents = true;
    this.isLoadingUpcomingRegisteredEvents = true;

    this.publicEventsService.fetchUserFavoritesEvent().pipe(tap(()=>this.isLoadingFavoriteItems = false)).subscribe((value)=> this.favoriteItems = value ?? []);
    this.publicEventsService.fetchUserUpcomingRegisteredEvents().pipe(tap(()=>this.isLoadingUpcomingRegisteredEvents = false)).subscribe((value)=> this.upcomingRegisteredEvents = value ?? []);
    this.publicEventsService.fetchUserPastRegisteredEvents().pipe(tap(()=>this.isLoadingPastRegisteredEvents = false)).subscribe((value)=> this.pastRegisteredEvents = value ?? []);
  }

  calculateActiveTab(): number {
    switch (this.tab) {
      case "favorites":
        return 2;
      case "upcoming":
        return 1;
      case "finished":
        return 3;
      default:
        return 1;
    }
  }

  trackByFn(index: number, item: EventItem) {
    return item.id || index;
  }

  goToEventDetailsPage(item: EventItem, isFinishedEvent: boolean, isFavourite?: boolean): void {
    this.router.navigate([EVENT_DETAILS], {
      relativeTo: this.route,
      queryParams: {eventId: item.id, isFinishedEvent: isFinishedEvent, isFavourite: isFavourite},
    });
  }

  loadMore(): void {
  }
}
